import { Injectable, signal } from '@angular/core';
import type { Theme } from '@fino-ui/theming';
import { ThemingService } from '@fino-ui/theming';
import { TranslateService } from '@fino-ui/translation';
import { KeycloakService } from 'keycloak-angular';
import { ToastrService } from 'ngx-toastr';
import { THEMES } from './core/environment/config.loader';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  logoUrl = signal('https://cdn.meinkontowechsel.de/logo.fino.png');
  faqCategories = signal([]);
  availableProducts = signal({
    hasKwh: false,
    canConfigureKwh: false,
    canConfigureKws: false,
    hasKws: false,
    hasDws: false,
  });

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
    private authService: KeycloakService,
    private themeService: ThemingService,
  ) {}

  get tenant() {
    return this.authService.getKeycloakInstance().tokenParsed?.tenant;
  }

  get themeName() {
    return (this.themeService.getTheme() as Theme).name;
  }

  get isAtruvia() {
    return (
      this.themeName === THEMES.VR ||
      this.themeName === THEMES.EVANGELISCHE_BANK
    );
  }

  success(
    subtitle: string,
    subtitleParams = {},
    title: string = 'toast.success',
  ) {
    this.toastr.success(
      this.translate.instant(subtitle, subtitleParams),
      this.translate.instant(title),
    );
  }

  error(subtitle: string, subtitleParams = {}, title: string = 'toast.error') {
    this.toastr.error(
      this.translate.instant(subtitle, subtitleParams),
      this.translate.instant(title),
    );
  }
}
